module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Extrabold.53f5a0b9.woff";